export enum CdrCallStatus {
  ANSWERED = 'ANSWERED',
  NOANSWER = 'NOANSWER',
  BUSY = 'BUSY',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}

export enum CdrCallDirection {
  INBOUND = 'Inbound',
  OUTBOUND = 'Outbound',
}

export enum SipResponseCode {
  OK = 200,
  RINGING = 180,
  BUSY = 486,
  UNAVAILABLE = 480,
  REQUEST_TIMEOUT = 408,
  TEMPORARILY_UNAVAILABLE = 503,
}
